import Image from 'next/image';
import { useSelector } from 'react-redux';
import Card from '../Card';
import { IRootState } from 'ui/store';
import { Product } from '../../../interface';

interface ICarGallery {
  subtitle?: string;
  code?: string;
  coverImg?: string;
  altImgText?: string;
  classNames?: string;
  textHarga?: string;
  onSelectedCar?: () => void;
  selectedCar?: Product;
  dataCar: Product;
  optimize?: boolean;
  priority?: boolean;
}

const CarGallery = ({
  subtitle = '',
  code = '',
  coverImg = '',
  altImgText = '',
  classNames = '',
  textHarga = '',
  onSelectedCar = () => {},
  selectedCar,
  dataCar,
  optimize = true,
  priority,
}: ICarGallery) => {
  const { isMobileScreen } = useSelector((state: IRootState) => state.page);
  const isHidePrice = dataCar?.isHidePrice,
    isPreorder = dataCar?.isPreorder,
    strikeThroughPrice = dataCar?.strikeThroughPrice,
    price = dataCar?.price,
    realPrice =
      strikeThroughPrice?.value > 0 ? strikeThroughPrice?.formattedValue : price?.formattedValue,
    discountPrice =
      strikeThroughPrice?.value !== price?.value &&
      strikeThroughPrice?.value > 0 &&
      strikeThroughPrice?.formattedValue
        ? dataCar?.price?.formattedValue
        : null;

  return (
    <div onClick={onSelectedCar}>
      <Card
        className={`h-full border-b border-reliableBlack20 ${selectedCar?.code === code ? 'border-supportiveRed' : 'border-inherit'} ${classNames}`}
      >
        <div className="absolute" style={{ left: '16px', top: '10px' }}>
          {selectedCar?.code === code && (
            <div
              className={`w-[30px] h-[30px] border rounded-full ${
                selectedCar?.code === code
                  ? 'bg-supportiveRed border-supportiveRed'
                  : 'bg-inherit border-supportiveRed hover:bg-reliableBlack10'
              } `}
            >
              <svg
                className="w-6 h-6 
               absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
          )}
        </div>
        {!isMobileScreen ? (
          <div className="pt-2 px-3 pb-5 mr-4 mb-4">
            <Image
              src={coverImg}
              alt={altImgText}
              className="aspect-video w-full object-cover mb-2 opacity-100"
              fetchPriority={optimize && priority ? 'high' : 'low'}
              width={256}
              height={144}
            />

            <div className="flex flex-col justify-between min-h-[2.5rem]">
              <p
                className={`h-14 text-xs font-medium text-reliableBlack line-clamp-2 lg:text-lg lg:font-semibold lg:mb-3 overflow`}
              >
                {subtitle}
              </p>
            </div>
            {!isHidePrice && (
              <>
                <p className="text-[10px] text-reliableBlack70 font-medium lg:text-sm lg:font-normal">
                  {textHarga}
                </p>
                <div className="flex flex-col">
                  <p className="md:text-base text-sm font-bold text-supportiveRed lg:text-lg lg:font-semibold mb-0 line-clamp-2">
                    {realPrice ? realPrice : 'Harga Belum Tersedia'}
                    {isPreorder ? ' (Pre-Order)' : ''}
                  </p>
                  {!dataCar?.isPreorder && !!discountPrice && (
                    <p className="font-medium line-through text-[#656263] lg:text-base text-[10px]">
                      {discountPrice}
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="py-4 px-3 flex justify-between items-center border-b border-[#C6C6C6] max-h-[90px]">
            <div>
              <div className="flex flex-col justify-between">
                <p
                  className={`text-xs font-bold text-reliableBlack line-clamp-2 lg:text-lg lg:font-semibold lg:mb-3 overflow`}
                >
                  {subtitle}
                </p>
              </div>
              {!isHidePrice && (
                <>
                  <p className="text-[10px] text-reliableBlack70 font-medium lg:text-sm lg:font-normal">
                    {textHarga}
                  </p>
                  <div className="flex flex-col">
                    <p className="md:text-base text-sm font-bold text-supportiveRed lg:text-lg lg:font-semibold mb-0 line-clamp-2">
                      {realPrice ? realPrice : 'Harga Belum Tersedia'}
                      {isPreorder ? ' (Pre-Order)' : ''}
                    </p>
                    {!dataCar?.isPreorder && !!discountPrice && (
                      <p className="font-medium line-through text-[#656263] lg:text-base text-[10px]">
                        {discountPrice}
                      </p>
                    )}
                  </div>
                </>
              )}
            </div>
            <div>
              {coverImg && (
                <Image
                  src={coverImg}
                  alt={altImgText}
                  width={100}
                  height={47}
                  className="object-fit mb-4"
                />
              )}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

CarGallery.defaultProps = {
  title: '',
  subtitle: '',
  slug: '',
  coverImg: '',
  altImgText: '',
  classNames: '',
  price: '',
  textHarga: '',
  onSelectedCar: () => {},
};

export default CarGallery;
